import _ from 'lodash';
import Vue from 'vue';

export default ({ app, router, store }) => {
  const isAndroid = !!(window.NativeCaller && window.NativeCaller.execNative);
  const isIOS = !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.bytJsToOc);
  const isAvailable = isAndroid || isIOS;
  const baseNative = {
    get isAvailable() {
      return isAvailable;
    },
    get isAndroid() {
      return isAndroid;
    },
    get isIOS() {
      return isIOS;
    },
    close() {
      try {
        window.close();
      } catch (e) {
        //--
      }
    }
  };
  const native = _.extend(baseNative, isAvailable && {
    /**
     * 获取原生APP信息
     * @return
     *  {
     *    platform: {String} 平台号。1苹果; 2安卓；
     *    nativeVersion: {String} 原生版本号。例：1.1.0
     *    width: {String} 屏幕宽度。像素
     *    height: {String} 屏幕高度。像素
     *    isFullScreen: {String} 是否全屏，1全屏；0带导航栏
     *  }
     */
    getNativeInfo() {
      return new Promise((resolve, reject) => {
        this._callNative({
          actionName: 'GET_NATIVE_INFO', // 请求接口名
          reqParams: null, // 请求参数
          callBack(msg) {
            if (msg.response && msg.response.code === 0) {
              resolve(formatResponse(msg));
            } else {
              reject(formatResponse(msg));
            }
          }
        });
      });
    },

    /**
     * 获取登录信息
     * @return
     *  {
     *    token: {String}
     *    empId: {String}
     *  }
     */
    getLoginInfo() {
      return new Promise((resolve, reject) => {
        this._callNative({
          actionName: 'GET_LOGIN_INFO', // 请求接口名
          reqParams: null, // 请求参数
          callBack(msg) {
            if (msg.response && msg.response.code === 0) {
              resolve(formatResponse(msg));
            } else {
              reject(formatResponse(msg));
            }
          }
        });
      });
    },

    /**
     * 设置状态栏模式
     * @param {Object} opt
     *   isLightMode: true：浅色模式（深色字体/标）; false：深色模式（浅色字体/标）
     * @return
     *   {String} actionResult: 1，设置成功
     */
    setStatusBarMode(opt) {
      return new Promise((resolve, reject) => {
        this._callNative({
          actionName: 'SET_STATUS_BAR_MODE', // 请求接口名
          reqParams: opt, // 请求参数
          callBack(msg) {
            if (msg.response && msg.response.code === 0) {
              resolve(formatResponse(msg));
            } else {
              reject(formatResponse(msg));
            }
          }
        });
      });
    },
    // 登录
    login() {
      return new Promise((resolve, reject) => {
        this._callNative({
          actionName: 'DO_LOGIN', // 请求接口名
          reqParams: null, // 请求参数
          callBack(msg) {
            if (msg.response && msg.response.code === 0) {
              resolve(formatResponse(msg));
            } else {
              reject(formatResponse(msg));
            }
          }
        });
      });
    },
    // 关闭
    close() {
      return new Promise((resolve, reject) => {
        this._callNative({
          actionName: 'CLOSE', // 请求接口名
          reqParams: null, // 请求参数
          callBack(msg) {
            if (msg.response && msg.response.code === 0) {
              resolve(formatResponse(msg));
            } else {
              reject(formatResponse(msg));
            }
          }
        });
      });
    },
    // 外部调用原生接口
    callNative(actionName, params) {
      return new Promise((resolve, reject) => {
        this._callNative({
          actionName, // 请求接口名
          reqParams: params, // 请求参数
          callBack(msg) {
            if (msg.response && msg.response.code === 0) {
              resolve(formatResponse(msg));
            } else {
              reject(formatResponse(msg));
            }
          }
        });
      });
    },
    // 内部调用原生接口
    _callNative(reqMsg) {
      reqMsg.actionId = reqMsg.actionId || `jsReqMsg${randomString(16)}`;
      let message = _.chain(reqMsg).pick(['actionName', 'reqParams', 'actionId']).valueOf();

      if (isIOS) {
        window.webkit.messageHandlers.bytJsToOc.postMessage(JSON.stringify(message));
      } else if (isAndroid) {
        window.NativeCaller.execNative(JSON.stringify(message));
      } else {
        // 没有找到
        message.response = {
          code: 1,
          message: '没有找到native方法'
        };
        reqMsg.callBack(message);
        return;
      }

      // 调用成功，放进队列等待处理结果
      putInQueue(reqMsg);
    },
    // 内部回调原生接口
    _callbackNative(resMsg) {
      if (isIOS) {
        window.webkit.messageHandlers.bytJsToOc.postMessage(JSON.stringify(resMsg));
      } else if (isAndroid) {
        window.NativeCaller.execNative(JSON.stringify(resMsg));
      } else {
        app.log('没有找到native方法');
      }
    }
  });
  // 请求的消息队列
  let reqQueue = [];
  // 获取随机数
  function randomString(length) {
    let str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let result = '';
    for (let i = length; i > 0; --i) { result += str[Math.floor(Math.random() * str.length)]; }
    return result;
  }
  // 放进队列
  function putInQueue(msg) {
    let atIndex = _.findIndex(reqQueue, { actionId: msg.actionId });
    if (atIndex > -1) {
      // 先删除相同请求
      reqQueue.splice(atIndex, 1);
    }
    // 放入新的请求
    reqQueue.push(msg);
  }
  // 取出
  function putOutQueue(msg) {
    let atIndex = _.findIndex(reqQueue, { actionId: msg.actionId });
    let queueItem = null;

    if (atIndex > -1) {
      queueItem = reqQueue.splice(atIndex, 1).pop();
    }

    return queueItem;
  }
  //! OC调用JS入口 ，bytOcToJs 为两端协商好的方法
  function bytNativeCallJs(responseMsg) {
    // var responseMsg = JSON.parse(msgString);
    let jsReqMsg = putOutQueue(responseMsg);

    if (jsReqMsg && jsReqMsg.actionId) {
      // 返回js请求结果
      jsReqMsg.callBack(responseMsg);
    } else {
      // 处理原生请求
      return handNativeAction(responseMsg);
    }
  }

  function handNativeAction(nativeReqMsg) {
    switch (nativeReqMsg.actionName) {
      case 'BACK':
        if (window.history.state) {
          router.back();
        } else {
          native.close();
        }
        native._callbackNative(_.extend(nativeReqMsg, {
          response: {
            code: 0,
            success: true,
            message: 'success'
          }
        }));
        break;
      default:
        native._callbackNative(_.extend(nativeReqMsg, {
          response: {
            code: 1,
            success: false,
            message: 'not support this method'
          }
        }));
    }
    return '1';
  }

  function formatResponse(msg) {
    return {
      code: (msg.response.code === 0 ? 200 : (400 + Number(msg.response.code))),
      success: msg.response.code === 0,
      message: msg.response.message,
      data: msg.response.data
    };
  }

  if (isAvailable) {
    if (store) {
      store.state.sets.clientMode = 'app';
    }
    window.bytNativeCallJs = bytNativeCallJs;
  }
  Vue.use({
    install() {
      Vue.prototype.$native = native;
    }
  });
  app.native = native;
};
